var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSearchNoResult({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.2 0c26.068 0 47.2 21.132 47.2 47.2S73.268 94.4 47.2 94.4 0 73.268 0 47.2c0-2.849.252-5.639.736-8.349A32.058 32.058 0 0 1 0 32C0 14.327 14.327 0 32 0c2.352 0 4.645.254 6.852.735A47.543 47.543 0 0 1 47.2 0z",
    id: "if7j1k06ta"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0c17.673 0 32 14.327 32 32a31.857 31.857 0 0 1-6.262 19.018c1.77-.22 3.619.351 4.978 1.71l26.87 26.87a6 6 0 1 1-8.485 8.486l-26.87-26.87a5.986 5.986 0 0 1-1.745-4.632A31.862 31.862 0 0 1 32 64C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0zm0 9C19.297 9 9 19.297 9 32s10.297 23 23 23 23-10.297 23-23S44.703 9 32 9z",
    id: "27znbgm81d"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.5%",
    y: "-3.3%",
    width: "113.1%",
    height: "113.4%",
    filterUnits: "objectBoundingBox",
    id: "15zqo7wgyc"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.819 0 0 0 0 0.849375 0 0 0 0 0.9 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 13)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "zwu1rt68xb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#if7j1k06ta"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F5F8FA",
    xlinkHref: "#if7j1k06ta"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#zwu1rt68xb)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#15zqo7wgyc)",
    xlinkHref: "#27znbgm81d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CAD0DB",
    xlinkHref: "#27znbgm81d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSearchNoResult);
export default __webpack_public_path__ + "static/media/ico-search-no-result.277e10c4ff1432b4299e245f170533b5.svg";
export { ForwardRef as ReactComponent };